import { colors } from 'fitify-ui'
import { Typography } from 'fitify-ui-landing/src/components/Typography/Typography'
import { useTranslation } from 'next-i18next'
import { useMemo, useState } from 'react'

import {
  StyledBadge,
  StyledBadges,
} from '@/components/exercises/Exercise/Badge/Badge.Styled'
import {
  StyledCard,
  StyledContent,
  StyledThumbnail,
} from '@/components/exercises/ExerciseCard/ExerciseCard.Styled'
import {
  type ExerciseListItem,
  getMuscleI18nKey,
  getPrimaryMuscles,
  getToolI18nKey,
} from '@/utils/exercises'

type ExerciseCardProps = {
  exercise: ExerciseListItem
}

export const ExerciseCard = ({ exercise }: ExerciseCardProps) => {
  const { t } = useTranslation()
  const [broken, setBroken] = useState(false)

  const primaryMuscleNames = useMemo(() => {
    return getPrimaryMuscles(exercise.muscle_intensity)
      .slice(0, 3)
      .map((muscle) => t(getMuscleI18nKey(muscle.key)))
      .join(', ')
  }, [exercise.muscle_intensity, t])

  if (broken) return null

  return (
    <StyledCard
      href={`/exercises/${exercise.tool || 'bodyweight'}/${exercise.slug}`}
      prefetch={false}
    >
      <StyledThumbnail>
        {exercise.thumbnail && (
          <img
            src={exercise.thumbnail}
            alt={exercise.title}
            loading="lazy"
            onError={() => setBroken(true)}
          />
        )}
      </StyledThumbnail>

      <StyledContent>
        <Typography
          $color={colors.Black}
          $variant="Headline/H 16"
          $variantPhone="Headline/H 14"
        >
          {exercise.title}
        </Typography>
        {primaryMuscleNames && (
          <Typography
            $color={colors.Gray600}
            $variant="Text/Body 14"
            $variantPhone="Text/Body 12"
          >
            {t('landing_exercises_targets', { muscles: primaryMuscleNames })}
          </Typography>
        )}
        <StyledBadges $gap={6}>
          <StyledBadge $variant="blue" $size="sm">
            {t(getToolI18nKey(exercise.tool))}
          </StyledBadge>
        </StyledBadges>
      </StyledContent>
    </StyledCard>
  )
}
